import React from 'react'
import styled from 'styled-components'
import {
  SEARCH_INPUT_TYPE,
  SearchInput
} from '../../components/SearchInput/SearchInput'
import {_L, useLocaleState} from '../../context/LocaleContext'

const ServiceCatalogSearch = ({searchValue, onSearch}) => {
  const localeState = useLocaleState()
  const getPlaceHolderText = () => {
    return _L({
      key: 'How can we help you?',
      localeState
    })
  }

  const onSearchCancel = () => {
    onSearch('')
  }
  return (
    <Container>
      <SearchInput
        type={SEARCH_INPUT_TYPE.CONTENT}
        value={searchValue}
        onSearchChange={e => {
          e.preventDefault()
          onSearch(e.target.value)
        }}
        placeholder={getPlaceHolderText()}
        onCancel={onSearchCancel}
      />
    </Container>
  )
}

export default ServiceCatalogSearch

const Container = styled.div`
  padding: 14px 0 14px 0;
  height: auto;
  width: 1427px;
  margin: 0 auto;

  @media (max-width: 1500px) {
    width: 1154px;
  }

  @media (max-width: 1245px) {
    width: 934px;
  }

  @media (max-width: 1023px) {
    width: 700px;
  }

  @media (max-width: 780px) {
    font-size: 17px;
    width: 100%;
  }

  @media (max-width: 420px) {
    font-size: 14px;
    padding: 14px 0px 0px 0px;
  }
`
